import Typography from '@material-ui/core/Typography'
import React from 'react'
import Link from '@material-ui/core/Link'
export default function Round20() {
  return (
    <Typography>
      Prints on 2" round, 20 per page precut 8.5x11" sticker paper.{' '}
      <Link href="https://www.amazon.com/Laser-Ink-White-Labels-Round/dp/B07FJMP29C">
        Buy from Amazon.
      </Link>
    </Typography>
  )
}
